import { Grid, makeStyles, Theme } from "@material-ui/core";
import React from "react";
import { RecordHeader } from "@ofqual/portal-components/components/RecordHeader";
import { ItemState } from "../../redux/state";
import { formatUtcDate } from "@ofqual/portal-core/core/utils/dateUtils";
import { standardDateFormats } from "@ofqual/portal-core/core/utils/dateUtils";
import { CommissionStatus } from "../../domain/CommissionModel";

const useStyles = makeStyles((theme: Theme) => {
  return {
    gridItem: {
      borderRight: "1px solid rgba(255,255,255,0.2)",
      padding: "0 15px",
      "& div": {
        padding: "5px",
      },
    },
  };
});

type ItemHeaderProps = {
  state: ItemState;
};

export const ItemHeader: React.FC<ItemHeaderProps> = ({ state }) => {
  const classes = useStyles();
  return (
    <RecordHeader>
      <Grid
        container
        direction="row"
        justify="flex-start"
        alignItems="stretch"
        spacing={2}
        style={{ height: "100%" }}
      >
        <Grid className={classes.gridItem}>
          <div>
            <label>
              <strong>Title:</strong>
            </label>{" "}
            <span data-test="commission-item-heading-title">{state.item?.title}</span>
          </div>
          <div>
            <label>
              <strong>Created by:</strong>{" "}
              </label>
              <span data-test="commission-item-heading-created-by">{state.item?.createdByDisplayName}</span>
          </div>
          <div>
            <label>
              <strong>Created at:</strong>
              </label>{" "}
              <span data-test="commission-item-heading-created-at">{ formatUtcDate( state?.item?.createdDate, standardDateFormats.DATE_TIME  )}</span>
          </div>
        </Grid>
        <Grid className={classes.gridItem}>
          <div>
            <label>
              <strong>Modified by:</strong>{" "}
              </label>
              <span data-test="commission-item-heading-modified-by">{state.item?.modifiedByDisplayName}</span>
          </div>
          <div>
            <label>
              <strong>Modified at:</strong>
              </label>{" "}
              <span data-test="commission-item-heading-modified-at">{ formatUtcDate( state?.item?.modifiedDate, standardDateFormats.DATE_TIME  )}</span>
          </div>
        </Grid>

        <Grid className={classes.gridItem}>
            <div>              
              <label><strong>Status:</strong>{" "}</label>
              <span data-test="commission-item-heading status">{ CommissionStatus[state?.item?.status || 0] }</span>
            </div>
        </Grid>
      </Grid>
    </RecordHeader>
  ); 
};
